import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { COLUMNS } from './columns'
import Table from "../../common/Table/Table";
import AddUserButton from "../../common/AddUserButton/AddUserButton";
import { Link } from "react-router-dom";
import { PencilIcon, TrashIcon, PlusIcon } from '@heroicons/react/outline';
import PlanService from "../../../services/PlanService";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const PlanHistory = () => {
    let { clientId } = useParams();
    let history = useHistory();
    const [buttonText, setButtonText] = useState('Dodaj Plan')
    const [measurementsData, setPlansHistoriesData] = useState(null)

    useEffect(() => {
        getPlanHistory()
    }, [])

    const getPlanHistory = () => {
        PlanService.getPlanByClientId(clientId).then((response) => {
            setPlansHistoriesData(response.data)
        });
    };

    const deletePlan = (id) => {
        MySwal.fire({
            showCancelButton: true,
            showDenyButton: true,
            showConfirmButton: false,
            denyButtonText: `Obriši`,
            cancelButtonText: `Otkaži`,
        }).then((result) => {
            if (result.isDenied) {
                PlanService.deletePlan(id).then(response => {
                    getPlanHistory()
                });
            }
        })

    };

    const openModal = (row) => {
        history.push("/home/plans/" + row.original.clientId + "/" + row.original.id)
    };

    const additionalColumn = {
        Header: ' ',
        Cell: ({ row }) => (
            <div className="flex items-center justify-end">
                <span className="p-2 rounded-full transition cursor-pointer purpleGradient" title="Obriši" onClick={() => deletePlan(row.original.id)}><TrashIcon className="w-4 h-4 text-white transition" /></span>
            </div>
        )
    }
    return (
        <>
            <Link className="button with-icon bg-blueSecondary w-40 mt-3 md:mt-0 lg:mr-3" to={{ pathname: "/home/plans/" + clientId + "/:planId" }} > {buttonText} <PlusIcon /></Link>
            {measurementsData !== null ?
                <Table openModal={openModal} columnsProp={COLUMNS} dataProp={measurementsData} additionalColumn={additionalColumn} setPlanHistoryData={setPlansHistoriesData} />
                : null}
        </>
    )

};

export default PlanHistory;
